// @flow
import React from 'react';
import { injectIntl } from 'react-intl';
import { FieldArray } from 'redux-form';
// $FlowFixMe - LaunchDarkly types not available
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Row, Col } from 'react-bootstrap';
import ContactFieldArray from '../../components/EditHouseholdForm/ContactFields/ContactFieldArray';

type Props = {
  intl: Object,
  disabled?: boolean,
  change: Function,
  form: string,
  fieldPrefix?: string,
};

const ResidentContactFields = ({
  intl,
  disabled = false,
  change,
  form,
  fieldPrefix = 'contactInformation',
}: Props) => {
  const { addlContactInfoResidents } = useFlags();

  // Only render the additional contact fields if feature flag is enabled
  if (!addlContactInfoResidents) {
    return null;
  }

  return (
    <Row>
      <div className="container-of-inputs">
        <Col xs={12} sm={6}>
          <FieldArray
            name={`${fieldPrefix}.phones`}
            component={ContactFieldArray}
            type="phone"
            disabled={disabled}
            intl={intl}
            layout="vertical"
            required={true}
            change={change}
            form={form}
          />
        </Col>
        <Col xs={12} sm={6}>
          <FieldArray
            name={`${fieldPrefix}.emails`}
            component={ContactFieldArray}
            type="email"
            disabled={disabled}
            intl={intl}
            layout="vertical"
            required={false}
            change={change}
            form={form}
          />
        </Col>
      </div>
    </Row>
  );
};

export default (injectIntl(ResidentContactFields): any);
